import { render } from "./YourAccount.vue?vue&type=template&id=6cd2b57a"
import script from "./YourAccount.vue?vue&type=script&lang=js"
export * from "./YourAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__